import React, { useEffect, useState } from "react";
import { getSchulprofil } from "../lib/api";
import { Page, PageHeader, Section, SectionHead, EditorialBlock, CardGrid } from "../components/ui";
import IconByName from "../components/IconByName";
import "../styles/ProfilPage.css";

export default function SchulprofilWertePage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getSchulprofil()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const { heroTitle, heroSubtitle, sectionTitle, sectionSubtitle, editorialBlocks, factsTitle, factsSubtitle, facts } =
    data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Über Uns", to: "/" }}
        current="Pädagogisches Profil"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section>
        <SectionHead title={sectionTitle} subtitle={sectionSubtitle} />

        {(editorialBlocks || []).map((block, i) => (
          <EditorialBlock
            key={block.id ?? i}
            icon={<IconByName name={block.icon} />}
            kicker={block.kicker}
            title={block.title}
            text={block.text}
            image={block.image}
            align={i % 2 === 0 ? "left" : "right"}
          />
        ))}
      </Section>

      {/* The 3x3 flyer-style facts grid is unique to this page — its
          centered handwritten heading and per-card pastel colours
          don't fit the shared SectionHead/CardGrid pattern, so they
          stay page-specific. */}
      <Section>
        <div className="rs-facts-head">
          <h2 className="rs-facts-title">{factsTitle}</h2>
          <p className="rs-facts-subtitle">{factsSubtitle}</p>
        </div>

        <CardGrid cols={3} className="rs-flyer-grid">
          {(facts || []).map((item, i) => (
            <FlyerCard key={item.id ?? i} title={item.title} text={item.text} />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}

function FlyerCard({ title, text }) {
  return (
    <article className="rs-flyer-card">
      <h3>{title}</h3>
      {text ? (
        <p>
          {text.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      ) : null}
    </article>
  );
}